// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getVisibilityById } from 'app/constants/enums/Visibility/main';

/* eslint-disable max-len */
export const PRIVATE = getVisibilityById('Private');
export const PUBLIC = getVisibilityById('Public');
export const UNLISTED = getVisibilityById('Unlisted');
/* eslint-enable max-len */
